// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Loading from './Loading'

type Props = {
  active?: boolean,
  container: any,
  delay?: number,
  opacity?: number,
}

export default class BlockingLoadingStatus extends React.PureComponent<Props> {
  static defaultProps = {
    delay: 200,
    opacity: 1,
  };

  render() {
    if (!this.props.container) return null;

    return ReactDOM.createPortal(
      <div
        css={[
          {
            pointerEvents: 'none',
            opacity: 0,
            width: '100%',
            height: '100%',
            background: `rgba(255, 255, 255, ${this.props.opacity})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1000,
            // $FlowFixMe
            transition: `opacity ${this.props.delay}ms ease-in-out`,
          },
          this.props.active && {
            pointerEvents: 'auto',
            opacity: 1,
          },
          this.props.excludeHeader && {
            top: '160px',
            height: 'calc(100% - 160px)',
          },
        ]}
      >
        <Loading />
      </div>,
      this.props.container,
    );
  }
}
